import { style } from "@vanilla-extract/css";

export const indicator = style({
  fill: "#FFF",
  cursor: "pointer",
});

export const shadow = style({
  filter: "drop-shadow(0px 2px 18px #2C3137)",
});
